import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import ScrollBar from "react-perfect-scrollbar"
import { useFormik } from "formik"
import * as Yup from "yup"
import InspectionNotSelected from "../InspectionNotSelected"
import ListOrder from "./components/ListOrder"
import InspectionChecklist from "./components/InspectionChecklist"
import DetailInspection from "./components/DetailInspection"
import InspectionAction from "store/inspection-resource/actions"
import AssignmentAction from "store/assignment-resource/actions"

export default function InpectionBespoke() {
  const dispatch = useDispatch()
  const store = useSelector(state => state)
  const [selectedInspection, setSelectedInspection] = React.useState(null)

  const [filter, setFilter] = React.useState({
    weekId: "",
    keyword: "",
  })

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      finishingPress: false,
      inseamDimension: false,
      waistSize: false,
      needleDetector: false,
      specificationConfirmation: false,
      summaryFestival: false,
      canStopStitch: false,
      attachButton: false,
      pocketBag: false,
      pocketOpeningCloth: false,
      brandName: false,
      qualityEntryConfirmation: false,
      garbage: false,
      hemBasting: false,
      remarks: "string",
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      console.log(values)
      values.id = selectedInspection
      dispatch(InspectionAction.postRtwOrderData(values, callbackPost))
    },
  })

  React.useEffect(() => {
    dispatch(AssignmentAction.getWeekList({}, callbackGetWeekList))
  }, [])

  const callbackGetWeekList = data => {
    const filtered = data.find(i => i.currentWeek)
    setFilter({
      ...filter,
      weekId: filtered.id,
      weekName: `${filtered.startDate} - ${filtered.endDate}`,
    })
    dispatch(
      InspectionAction.getRtwOrderList({ ...filter, weekId: filtered.id })
    )
  }

  const callbackGetChecklist = data => {
    const editable = data.producerEditable ? data.producer : data.inspector
    validation.setValues(editable)
    validation.setFieldValue("remarks", data.remarks)
  }

  const callbackPost = () => {
    dispatch(
      InspectionAction.getRtwOrderDetail(
        selectedInspection,
        callbackGetChecklist
      )
    )
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"検品"} breadcrumbList={[]} />

        <Row>
          <Col xl="3" md="6">
            <Card>
              <CardBody>
                <Row>
                  <Col md="4">
                    <Label>作業期間</Label>
                  </Col>
                  <Col md="8">
                    <Select
                      isLoading={store.assignment.weekList.loading}
                      value={{
                        value: filter.weekId,
                        label: filter.weekName,
                      }}
                      options={store.assignment.weekList.data.map(i => ({
                        value: i.id,
                        label: `${i.startDate} - ${i.endDate}`,
                      }))}
                      onChange={e => {
                        if (e) {
                          setFilter({
                            ...filter,
                            weekId: e.value,
                            weekName: e.label,
                          })
                          dispatch(
                            InspectionAction.getRtwOrderList({
                              ...filter,
                              weekId: e.value,
                            })
                          )
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Input
                    value={filter.keyword}
                    placeholder="キーワード検索"
                    onChange={e => {
                      setFilter({ ...filter, keyword: e.target.value })
                      setTimeout(() => {
                        dispatch(
                          InspectionAction.getRtwOrderList({
                            ...filter,
                            keyword: e.target.value,
                          })
                        )
                      }, 1000)
                    }}
                  />
                </Row>
              </CardBody>
            </Card>

            <Card style={{ height: 515 }}>
              <CardBody>
                <ScrollBar>
                  <ListOrder
                    callbackGetChecklist={callbackGetChecklist}
                    setSelectedInspection={setSelectedInspection}
                    selectedInspection={selectedInspection}
                  />
                </ScrollBar>
              </CardBody>
            </Card>
          </Col>

          {!selectedInspection ? (
            <Col xl="9" md="6" style={{ height: 660 }}>
              <InspectionNotSelected />
            </Col>
          ) : (
            <>
              <Col xl="3" md="6">
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <InspectionChecklist
                    validation={validation}
                    selectedInspection={selectedInspection}
                  />
                </Form>
              </Col>
              <Col xl="5" md="12">
                <DetailInspection />
              </Col>
            </>
          )}
        </Row>
      </Container>
    </div>
  )
}
